export const TicketStatuses = [
    { label: "Open", value: "open" },
    { label: "Closed", value: "closed" },
]